import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M8.88261 7.39765C7.60261 2.66765 5.35262 0.28769 2.92262 1.18769C0.562616 2.05769 0.422608 6.26769 2.24261 12.3777C2.92261 14.6777 3.31262 18.5377 4.06262 20.9677C5.05262 24.1877 11.6626 28.8077 11.6626 28.8077C11.6626 28.8077 11.4026 16.7277 8.88261 7.39765Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.9525 12.7778C3.9525 12.7778 2.4125 6.83783 3.8125 5.12783C5.2025 3.42783 8.0525 7.04782 8.7625 17.6778"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M3.95255 12.7777C3.32255 10.9677 2.85254 9.08776 2.85254 7.10776C2.87254 6.60776 2.90254 6.09779 3.09254 5.57779C3.27254 5.08779 3.57253 4.43774 4.36253 4.27774C4.75253 4.21774 5.09253 4.33776 5.36253 4.48776C5.61253 4.65776 5.84254 4.83776 6.01254 5.04776C6.38254 5.44776 6.64254 5.88774 6.87254 6.33774C7.76254 8.13774 8.18254 10.0378 8.46254 11.9478C8.74254 13.8578 8.81254 15.7778 8.76254 17.6878C8.43254 15.7978 8.10254 13.9277 7.69254 12.0877C7.26254 10.2577 6.79254 8.41776 5.98254 6.79776C5.78254 6.39776 5.55255 6.00779 5.28255 5.70779C5.02255 5.37779 4.68255 5.18774 4.50255 5.21774C4.30255 5.20774 4.03254 5.51779 3.90254 5.88779C3.74254 6.25779 3.67254 6.70774 3.62254 7.15774C3.50254 8.96774 3.70255 10.8877 3.95255 12.7777Z"
        fill={outline}
      />
      <path
        d="M71.2326 7.39765C72.5126 2.66765 74.7626 0.28769 77.1926 1.18769C79.5526 2.05769 79.6926 6.26769 77.8726 12.3777C77.1926 14.6777 76.8026 18.5377 76.0526 20.9677C75.0626 24.1877 68.4526 28.8077 68.4526 28.8077C68.4526 28.8077 68.7126 16.7277 71.2326 7.39765Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M76.1528 12.7778C76.1528 12.7778 77.6928 6.83783 76.2928 5.12783C74.9028 3.42783 72.0528 7.04782 71.3428 17.6778"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M76.1528 12.7777C76.4028 10.8877 76.6128 8.97768 76.4728 7.14768C76.4228 6.69768 76.3528 6.24772 76.1928 5.87772C76.0628 5.50772 75.7928 5.19774 75.5928 5.20774C75.4128 5.18774 75.0728 5.36773 74.8128 5.69773C74.5428 5.99773 74.3128 6.38769 74.1128 6.78769C73.2928 8.40769 72.8228 10.2477 72.4028 12.0777C72.0028 13.9177 71.6728 15.7877 71.3328 17.6777C71.2828 15.7677 71.3528 13.8477 71.6328 11.9377C71.9128 10.0377 72.3428 8.12773 73.2228 6.32773C73.4628 5.88773 73.7228 5.44769 74.0828 5.03769C74.2528 4.82769 74.4828 4.6477 74.7328 4.4777C75.0128 4.3277 75.3428 4.20774 75.7328 4.26774C76.5228 4.42774 76.8228 5.07772 77.0028 5.56772C77.1928 6.08772 77.2228 6.59769 77.2428 7.09769C77.2628 9.08769 76.7828 10.9677 76.1528 12.7777Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.76853 5.4514) rotate(161.679) scale(5.55183 11.8251)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(72.2746 5.59541) rotate(18.3211) scale(5.55183 11.8251)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
